import './exportable_chart.js.coffee'

Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.EngagementRateHistogramView extends Monitoring.Reports.Campaign.ExportableChart

  className: 'engagment-rate-histogram'

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.addClass('processing')

    params = {
      account_id: @options.account_id,
      content_id: _.pluck(@options.content_id, 'content_id'),
      user:       @options.user,
      date_from:  @options.date_from_ISO,
      date_to:    @options.date_to_ISO,
      exclude_page_owner_generated: true
    }

    $.post('/monitoring/reports/campaign/' + @options.type + '_egmnt_rate_evolution', params, @_renderChart)
      

  _renderChart: (data) =>
    title = "Period engagement rate: " + data["period_egmnt"] + "%"
    @$el.highcharts({
      chart: 
        type: 'spline' 
        height: 400
        style: {fontFamily: "Roboto", "Helvetica Neue", "Helvetica", "Arial", "sans-serif"}
      title: 
        text: title
      tooltip: 
        valueSuffix: '%' 
      xAxis: 
        categories: data["xAxis"]
      yAxis:
        title: 
          text: "rate (%)"
        min: 0
      series: data["serie"]
    })

    @trigger('rendered')
